import axios from 'axios';
import {
  baseUrl,
} from '@/config';

export default {
  /**
   * [getNetinterfaceConfigGroupList 그룹 > 장비목록 리스트를 출력한다.]
   * @author {Yang}
   * @param  {[ConfigParamVO]} params [managegroupId...]
   * @return {[type]}        [description]
   */
  getNetinterfaceConfigGroupList(params) {
    return axios.post(`${baseUrl}/config/get-netinterface-group-config-list.do`, params);
  },
  /**
   * [exportNetinterfaceConfigGroupList 그룹 > 장비목록 리스트를 엑셀 출력한다.] - 필터링된 데이터만 엑셀출력 가능하도록 수정
   * @author {Yang -> NaJY}
   * @param  {[Integer]} managegroupId [managegroupId]
   * @return {[type]}               [description]
   */
  exportNetinterfaceConfigGroupList(params) {
    return axios.post(`${baseUrl}/config/export-netinterface-group-config-list.do`, params);
  },
  /**
   * 노드>구성관리 파라미터 정보
   * @author hyo
   * @param
   * @return
   */
  getNiObjInfoParams(params) {
    return axios.post(`${baseUrl}/config/get-ni-obj-info-params.do`, params);
  },
  /**
   * 노드>구성현황 기본정보
   * @author hyo
   * @param
   * @return
   */
  getNiConfigInfoBasic(params) {
    return axios.post(`${baseUrl}/config/get-ni-config-info-basicstatus.do`, params);
  },
  /**
   * 노드 > 구성현황 수정
   * @author hyo
   * @param
   * @return
   */
  updateNiConfigInfo(params) {
    return axios.post(`${baseUrl}/config/update-ni-obj-config.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/config/netinterface/netinterface-info.js